import type { Language } from './translations';
import type { ServiceKey } from './services';

type Localized = Record<Language, string>;
export const WOMEN_SERVICES: { key: ServiceKey; image: string; title: Localized; description: Localized }[] = [
  {
    key: 'packminceurcomplet', image: 'silhouette',
    title: { fr: 'Votre silhouette, à votre rythme', ar: 'قوامكِ، على إيقاعكِ', en: 'Your silhouette, your own pace' },
    description: { fr: 'Perdre 6 kg et 5 cm de tour de taille en 1 MOIS', ar: 'فقدان 6 كجم و5 سم من محيط الخصر خلال شهر واحد', en: 'Lose 6 kg and 5 cm from your waist in 1 MONTH' },
  },
  {
    key: 'epilation', image: 'laser',
    title: { fr: 'La douceur au quotidien', ar: 'نعومة ترافق يومكِ', en: 'Everyday softness' },
    description: { fr: 'Éliminez définitivement les poils indésirables en 6 SÉANCES', ar: 'تخلّصي نهائياً من الشعر غير المرغوب فيه خلال 6 جلسات', en: 'Permanently reduce unwanted hair in 6 SESSIONS' },
  },
  {
    key: 'hydrafacial', image: 'facial',
    title: { fr: 'Un moment pour votre peau', ar: 'لحظة عناية ببشرتكِ', en: 'A moment for your skin' },
    description: { fr: 'Résultat rapide & efficace en 1 SÉANCE', ar: 'نتيجة سريعة وفعّالة خلال جلسة واحدة', en: 'Fast and effective results in 1 SESSION' },
  },
  {
    key: 'teeth', image: 'smile',
    title: { fr: 'Souriez en toute confiance', ar: 'ابتسمي بكل ثقة', en: 'Smile with confidence' },
    description: { fr: 'Découvrez notre soin de blanchiment dentaire et échangez avec notre équipe sur vos attentes.', ar: 'اكتشفي خدمة تبييض الأسنان وتحدثي مع فريقنا عن توقعاتكِ.', en: 'Explore our teeth whitening service and discuss your expectations with our team.' },
  },
  {
    key: 'hifu', image: 'hifu',
    title: { fr: 'Une attention pour vos contours', ar: 'عناية بملامح وجهكِ', en: 'Care for your facial contours' },
    description: { fr: 'Un soin HIFU du visage à envisager après un échange sur votre peau et vos objectifs de fermeté.', ar: 'عناية HIFU للوجه تُناقش بعد تقييم بشرتكِ وأهدافكِ المتعلقة بالتماسك.', en: 'Explore facial HIFU after discussing your skin and your goals for firmness.' },
  },
  {
    key: 'powershape', image: 'powershape',
    title: { fr: 'Des soins du corps sur mesure', ar: 'عناية بالجسم تناسبكِ', en: 'Body care tailored to you' },
    description: { fr: 'Power Shape et lipocavitation : définissez avec notre équipe les zones et le programme qui vous correspondent.', ar: 'باور شيب وليبوكافيتيشن: حددي مع فريقنا المناطق والبرنامج المناسبين لكِ.', en: 'Power Shape and lipocavitation: explore the areas and care programme that suit you with our team.' },
  },
];

export const serviceImage = (image: string) => `/images/women-services/${image}.webp`;
export const serviceImageSet = (image: string) => `/images/women-services/${image}-768.webp 768w, ${serviceImage(image)} 1536w`;
